export const API_URL = process.env.REACT_APP_BURGERHOUSE_API_URL!;
